
import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';
import { Bar, Doughnut, Pie, Scatter } from 'react-chartjs-2';
import { Box, Divider, Grid, Typography } from "@mui/material";
import { GetColor } from "./RefColorFunctions";

const HomeBanner = (props) => {
    // ChartJS.register(ArcElement, Tooltip, Legend);
    /*
    {

        Visible:
        Order:
        ComponentType: "VIEW INSTANCE BANNER"
        Color: #123456AA
        BorderRadius: 0px 16px
        Label:Text
    }
    */
    const { Label, Color, BorderRadius, TextColor } = props.component
    const { settings } = props.otherprops
    // KeyToUse will be an array

    return (

        <Box sx={{ backgroundColor: Color ? Color : "transparant", borderRadius: BorderRadius ? BorderRadius : "0px" }}>
            <Typography ml={2} sx={{ color: TextColor ? TextColor : "#000000" }} variant="h5" textTransform={"uppercase"} align="left">{Label}</Typography>
        </Box>

    )
}

export default HomeBanner